// extracted by mini-css-extract-plugin
module.exports = {"hero_image":"_3KYYK","block_quote":"_3NAw5"};